import { isEmptyObject } from "../../../utils/tests";
import { CompetitionPredictedLineupsQuery } from '../types';

/**
 * typeguard for CompetitionPredictedLineupsQuery
 * @param CompetitionPredictedLineupsQuery object passed to transformer
 */
export const isValidCompetitionPredictedLineups = (obj: CompetitionPredictedLineupsQuery): boolean => Boolean(obj?.data?.competitionPredictedLineup && !isEmptyObject(obj.data.competitionPredictedLineup));
